import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SocialIcons from './SocialIcons';
import NewsletterSignup from './NewsletterSignup';
import { ShieldCheckIcon, TruckIcon, ArrowPathRoundedSquareIcon, BuildingStorefrontIcon, CreditCardIcon } from '@heroicons/react/24/outline';
import api from '../utils/api';

// Next.js sayfalarının URL'i
// Production'da aynı domain üzerinde path bazlı çalışıyoruz, bu yüzden base boş olmalı.
// Development'ta env yoksa localhost:3001'e düşer.
const NEXTJS_BASE_URL = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_NEXTJS_URL || 'http://localhost:3001');

// Next.js'de olan sayfalar
const NEXTJS_PAGES = [
  '/hakkimizda',
  '/sss',
  '/iletisim',
  '/beden-rehberi',
  '/bakim-rehberi',
  '/gizlilik-politikasi',
  '/iade-kosullari',
  '/teslimat-bilgileri'
];

function Footer() {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const data = await api('/api/settings');
                // --- HATA AYIKLAMA İÇİN EKLENEN SATIR ---
                // API'den gelen verinin ne olduğunu görmek için konsola yazdırıyoruz.
// console.log("API'den gelen ayarlar:", data); 
                setSettings(data);
            } catch (err) {
                console.error("Footer ayarları yüklenemedi:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    if (loading || !settings) {
        return (
            <footer className="bg-white border-t mt-12 py-4">
                <div className="container mx-auto text-center text-xs text-gray-500">
                    <p>&copy; {new Date().getFullYear()} Minela Kids. Tüm hakları saklıdır.</p>
                </div>
            </footer>
        );
    }

    const { featureItems, footerLinks, contactInfo } = settings;

    return (
        <footer className="bg-white border-t mt-12">
            <div className="border-b">
                <div className="container mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 p-8 text-center">
                    {(featureItems || []).map((item, index) => {
                        let IconComponent;
                        switch (item.icon) {
                            case 'ShieldCheckIcon': IconComponent = ShieldCheckIcon; break;
                            case 'TruckIcon': IconComponent = TruckIcon; break;
                            case 'ArrowPathRoundedSquareIcon': IconComponent = ArrowPathRoundedSquareIcon; break;
                            case 'BuildingStorefrontIcon': IconComponent = BuildingStorefrontIcon; break;
                            case 'CreditCardIcon': IconComponent = CreditCardIcon; break;
                            default: IconComponent = ShieldCheckIcon;
                        }
                        return (
                            <div key={index} className="flex flex-col items-center">
                                <IconComponent className="h-10 w-10 text-brand-green mb-2" strokeWidth={1.5} />
                                <span className="text-sm font-semibold text-text-dark">{item.text}</span>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="container mx-auto py-10 px-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
                {/* Bu bölümdeki kodun doğru çalıştığından emin olacağız. */}
                {footerLinks && Object.entries(footerLinks).map(([title, links]) => (
                    <div key={title}>
                        <h3 className="font-bold text-text-dark mb-4">{title}</h3>
                        <ul className="space-y-2">
                            {(links || []).map((link, index) => {
                                // Next.js sayfası mı kontrol et
                                const isNextJsPage = NEXTJS_PAGES.includes(link.path);
                                
                                return (
                                    <li key={index}>
                                        {isNextJsPage ? (
                                            <a 
                                                href={`${NEXTJS_BASE_URL}${link.path}`}
                                                className="text-sm text-gray-600 hover:text-brand-green hover:underline"
                                                target="_self"
                                            >
                                                {link.name}
                                            </a>
                                        ) : (
                                            <Link to={link.path} className="text-sm text-gray-600 hover:text-brand-green hover:underline">
                                                {link.name}
                                            </Link>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
                <div>
                    <h3 className="font-bold text-text-dark mb-4">İletişim</h3>
                    <div className="space-y-3 text-sm text-gray-600">
                        <p>{contactInfo?.address}</p>
                        <p>{contactInfo?.phone}</p>
                        <p>{contactInfo?.email}</p>
                        <div className="pt-2">
                            <SocialIcons contactInfo={contactInfo} />
                        </div>
                    </div>
                </div>
                
                {/* E-Bülten */}
                <div>
                    <NewsletterSignup compact={true} />
                </div>
            </div>

            <div className="bg-gray-100 py-4">
                <div className="container mx-auto text-center text-xs text-gray-500">
                    <p>&copy; {new Date().getFullYear()} Minela Kids. Tüm hakları saklıdır.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;